<template>
  <div >
    <div class="demo-wizard">
      <step-one v-if="currentStep === 1" />
      <step-two v-if="currentStep === 2" />
      <step-three v-if="currentStep === 3" />
      <step-four v-if="currentStep === 4" />
    </div>
    <step-five v-if="currentStep === 5" />
    <div class="demo-wizard">
      <Summary v-if="currentStep === 6" />
    </div>
  </div>
</template>

<script>
import StepOne from './steps/1'
import StepTwo from './steps/2'
import StepThree from './steps/3'
import StepFour from './steps/4'
import StepFive from './steps/5'
import Summary from './steps/6Summary.vue'

export default {
    name: 'DemoWizard',
    components: {
        StepOne,
        StepTwo,
        StepThree,
        StepFour,
        StepFive,
        Summary,
    },
    data() {
      return {

      }
    },
    computed: {
      currentStep() {
        return this.$store.state['demoWizard'].currentStep
      }
    },
    created() {
      const orderId = localStorage.getItem('order_id')
      // const demoWizardPathId = localStorage.getItem('demoWizardPathId')
      const demoWizardCompletedPaths = localStorage.getItem('demoWizardCompletedPaths')
      const completedIds = JSON.parse(demoWizardCompletedPaths)


      if(orderId){
        this.$store.commit('orderPreview/id', orderId);
        console.log('complletediddd--------', completedIds)
        if(completedIds && completedIds.length) {
          this.$store.commit('demoWizard/setCompletedPaths', completedIds)
          this.$store.commit('demoWizard/goToStep', 6)
        }
        // else {
        //   // this.$store.commit('demoWizard/setPathById', demoWizardPathId )
        //   // this.$store.commit('demoWizard/goToStep', 5)
        // }
        
      }
    },
    mounted() {
      // this.reference = this.items.reference
      // this.$store.dispatch('customerDetails/getExistingCustomer')
    },
    methods: {
      // start() {
      //     this.$store.commit('orderPreview/clearItems')
      //     this.customerDetails.is_guest = 1
      //     this.$store.dispatch('customerDetails/sendData', {customerDetails: this.customerDetails, reference: this.reference})
      // }
    }
}
</script>

<style lang="scss">
  .demo-wizard {
    .modal_content {
      @apply tw-rounded-md tw-p-4;
    }
  }
</style>
